import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UtilService} from './util.service';
import {PayWayModel} from '../model/PayWayModel';


@Injectable()
export class PaywayService {

  private paywayOption = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    withCredentials: false,
    responseType: 'text' as 'text'
  };

  constructor(private router: Router, private http: HttpClient, private utilService: UtilService) {
  }


  startPayWay(payWay: PayWayModel) {
    const url = this.utilService.getPayWayUrl();
    const body = new URLSearchParams();
    body.set('pgw_shop_id', payWay.pgw_shop_id);
    body.set('pgw_order_id', payWay.pgw_order_id);
    body.set('pgw_amount', payWay.pgw_amount);
    body.set('pgw_authorization_type', payWay.pgw_authorization_type);
    body.set('pgw_success_url', payWay.pgw_success_url);
    body.set('pgw_failure_url', payWay.pgw_failure_url);
    body.set('pgw_signature', payWay.pgw_signature);
    return this.http.post(url, body.toString(), this.paywayOption)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/payway.service.ts